import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, } from '@angular/router';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sgke012aResponseSearchResultList, Sgke021aRequest, Sgke032aResponseMiseisanInfo, Sgke901aRequest, Sgke901aResponse } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke901aService } from '../../../../../sg-ke-shared/services/used-sgke901a.service';
import { UsedSgke012aService } from '../../../sgke010d/services/used-sgke012a.service';
import { UsedSgke021aService } from '../../services/used-sgke021a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke020d',
  templateUrl: './sgke020d.component.html',
  styleUrl: './sgke020d.component.scss'
})
export class Sgke020dComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();
  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** 検索結果リスト */
  public searchResultList: Array<Sgke012aResponseSearchResultList>;
  /** 戻るボタン押下フラグ */
  private returnFlg: boolean = false
  /** ラジオボタン_入金消込 1 */
  public REGISTTYPE_NYUKIN = '1';
  /** ラジオボタン_振替 2 */
  public REGISTTYPE_FURIKAE = '2';
  /** ラジオボタン_返金 3 */
  public REGISTTYPE_HENKIN = '3';
  /** ラジオボタン_返金結果登録 4 */
  public REGISTTYPE_HENKAKU = '4';
  /** ラジオボタン_充当 5 */
  public REGISTTYPE_JUTO = '5';

  /** 入金種別 */
  registType: string = null;
  /** 未精算管理番号 */
  private kinkoMno: string;
  /** 未精算金履歴番号 */
  private kinkoRrkno: string;

  /**
   * コンストラクタ
   * @param {UsedSgke012aService} usedSgke012aService
   * @param {UsedSgke021aService} usedSgke021aService
   * @param {UsedSgke901aService} usedSgke901aService
   * @param {TimeApiService} timeApiService
   * @param {Router} router
   * @param {ActivatedRoute} route
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke020dComponent
   */
  constructor(
    private usedSgke012aService: UsedSgke012aService,
    private usedSgke021aService: UsedSgke021aService,
    private usedSgke901aService: UsedSgke901aService,
    private timeApiService: TimeApiService,
    private router: Router,
    public route: ActivatedRoute,
    public responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) {
    //　クエリパラメータを取得
    this.kinkoMno = this.route.snapshot.paramMap.get('kinkoMno');
    this.kinkoRrkno = this.route.snapshot.paramMap.get('kinkoRrkno');
  }
  /**
   * 初期処理
   * @memberof BillingBasicInfoMenuComponent
   */
  ngOnInit(): void {
    this.usedSgke012aService.searchedValueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        this.searchResultList = response.shtkInfo?.searchresultList;
      });

    // クエリパラメータから未精算金管理番号と未精算金履歴番号を取得

    //検索処理実施
    this.search();
  }

  /**
   * 終了時処理
   * @memberof Sgke020dComponent
   */
  ngOnDestroy(): void {
    if (!this.returnFlg) {
      this.usedSgke012aService.searchFormValue = null;
    }
    this.onDestroy$.next();
  }

  /**
   * 入金種別のラジオボタン押下時
   * @param {*} type
   * @memberof Sgke020dComponent
   */
  onChange(type: any): void {
    if (type) {
      this.clearErrorMsg();
    }
    this.registType = type;
  }
  /**
   * 入金情報クリック処理
   * @memberof Sgke020dComponent
   */
  onClickRcvmnyInfo(): void {

    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;

    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = this.searchResultList[0].visitornumber;
    // 支払契約番号
    let paymentContractNo: string = this.searchResultList[0].paymentContractNo;
    // 入金番号
    let paymentNo: string = this.searchResultList[0].receiveMoneyNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 入金番号
    if (paymentNo) {
      paramToOutside.c__paymentNo = paymentNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '2';

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く	
    window.open(`${url}${params}`, '_blank');

  }
  /**
   * 返金先確認はがき発行処理
   *  @memberof Sgke020dComponent
   */
  clickRpaytoCfrmPostCard(): void {
    const TYOHYODIVCD = '04';
    const FORMATNO = 'A1';
    const SSCRIPTDIV = '2';
    // エラーメッセージクリア
    this.clearErrorMsg();
    let kinkoMno = this.kinkoMno + "               ";
    let sgke901aRequest: Sgke901aRequest;
    sgke901aRequest = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      regCndt: {
        payCtrNo: this.searchResultList[0].paymentContractNo,
        tyohyoDivcd: TYOHYODIVCD,
        formatNo: FORMATNO,
        sscriptDiv: SSCRIPTDIV,
        kinkoMno: this.kinkoMno,
        kinkoRrkno: this.kinkoRrkno,
        kinkoUpdateSrno: this.searchResultList[0].kinkoUpdateSrno,
        kinkoexUpdatesequencenumber: this.searchResultList[0].kinkoexUpdatesequencenumber,
      }
    }
    this.registRepayCfrmPostCard(sgke901aRequest);
  }
  /**
   * 返金先確認はがき発行実行
   * @param request
   * @memberof Sgke020dComponent
   */
  registRepayCfrmPostCard(request: Sgke901aRequest): void {
    this.usedSgke901aService.doSgke901a(request).pipe(takeUntil(this.onDestroy$)).subscribe(
      this.responsecheck,
      error => {
      });
  }
  /**
 * 承認依頼リセット処理
 * @memberof Sgke020dComponent
 */
  apprevReqReset(): void {

    // エラーメッセージクリア
    this.clearErrorMsg();

    let sgke021aRequest: Sgke021aRequest;
    sgke021aRequest = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      regCndt: {
        kinkoMno: this.kinkoMno,
        kinkoRrkno: this.kinkoRrkno,
        kinkoStatuscode: this.searchResultList[0].kinkoStatuscode,
        kinkoUpdateSrno: this.searchResultList[0].kinkoUpdateSrno,
        kinkoexUpdatesequencenumber: this.searchResultList[0].kinkoexUpdatesequencenumber,
        repayjissekiRepaymngNo: null,
        repayAchievUpdateSrno: null,
        repayachievexUpdatesequencenumber: null
      }
    }
    // 返金依頼の場合は、値を設定
    if (this.searchResultList[0].kinkoStatuscode == '04') {
      sgke021aRequest.regCndt.repayjissekiRepaymngNo = this.searchResultList[0].repayMno;
      sgke021aRequest.regCndt.repayAchievUpdateSrno = this.searchResultList[0].repayAchievUpdateSrno;
      sgke021aRequest.regCndt.repayachievexUpdatesequencenumber = this.searchResultList[0].repayachievexUpdatesequencenumber;
    }
    this.executedoSgke021a(sgke021aRequest);
  }
  /**
   * 未精算整理詳細承認取消処理
   * @param {Sgke021aRequest} request
   * @memberof Sgke020dComponent
   */
  executedoSgke021a(request: Sgke021aRequest) {
    this.usedSgke021aService.doSgke021a(request).pipe(takeUntil(this.onDestroy$)).subscribe(
      this.responsecheck,
      error => {
      });
  }
  /**
   * 戻るボタン押下時処理
   * @memberof Sgke020dComponent
   */
  returnPage() {
    this.returnFlg = true;
    this.router.navigate(['sgke/sgke010d']);
  }
  /**
   * 検索処理
   * @memberof Sgke020dComponent
   */
  public search(miseisanInfo: Sgke032aResponseMiseisanInfo = null) {
    // SGKE030D～SGKE070Dで登録ボタン押下後再検索されるときのみ、未精算情報を更新する
    if (miseisanInfo) {
      this.kinkoMno = miseisanInfo.kinkoMno;
      this.kinkoRrkno = miseisanInfo.kinkoRrkno;
    }

    {
      // リクエスト処理を追加
      let request = {
        requestCommon: {
          businessDate: null,
          dryRun: null,
          businessReqId: null,
          funcLinkId: null,
          requestCustomize: null,
        },
        extractionconditionInfo: {
          detailsinformationSearchFlg: true,
          payCtrNo: null,
          rcvmnyNo: null,
          kinkoOccurymdStart: null,
          kinkoOccurymdEnd: null,
          rcvmnyKeitaiCode: null,
          rcvmnyFcltCode: null,
          kinkoReasonCode: null,
          kinkoStatuscode: null,
          kinkoManagementinformation: {
            kinkoMno: this.kinkoMno,
            kinkoRrkno: this.kinkoRrkno
          }
        }
      };

      this.searchResultList = new Array<Sgke012aResponseSearchResultList>();
      this.usedSgke012aService.searched = false;
      this.usedSgke012aService.doSgke012a(request).pipe(takeUntil(this.onDestroy$)).subscribe(
        response => {
          if (response) {
            if (response?.shtkInfo?.searchresultList && response.shtkInfo.searchresultList.length !== 0) {
              this.searchResultList = response.shtkInfo.searchresultList;
            } else if (this.searchResultList) {
              this.searchResultList.length = 0;
            }
            // メッセージ表示
            this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
          }
        },
        error => {
        }
      );
    }
  };

  /**
   * 実行結果確認共通処理
   * @private
   * @memberof Sgke020dComponent
   */
  private responsecheck = (response: any) => {
    if (response) {
      // メッセージを表示
      this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      // 正常終了であれば再検索
      if (response.responseCommon.resultCode === "0") {
        this.search();
      }

    }
  }

  /**
   * エラーメッセージ表示
   * @memberof Sgke020dComponent
   */
  showMsg(errors) {
    // メッセージを表示
    this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(errors, this.errorMessageModelArray);
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @memberof Sgke020dComponent
   */
  clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

}